"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require(".");

var FoundParasite =
/** @class */
function () {
  function FoundParasite() {
    this.id = null;
    this.imageUrl = null;
    this.confidence = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.testedParasiteId = null;
    this.testedParasite = null;
  }

  FoundParasite.thaw = function (foundParasiteObj) {
    var _a, _b;

    if (foundParasiteObj == null) return null;
    var foundParasite = new FoundParasite();

    if (foundParasiteObj.id != null) {
      foundParasite.setId(foundParasiteObj.id);
    }

    if (foundParasiteObj.imageUrl != null) {
      foundParasite.setImageUrl(foundParasiteObj.imageUrl);
    }

    if (foundParasiteObj.confidence != null) {
      foundParasite.setConfidence(foundParasiteObj.confidence);
    }

    if (foundParasiteObj.createdAt != null) {
      foundParasite.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(foundParasiteObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (foundParasiteObj.updatedAt != null) {
      foundParasite.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(foundParasiteObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (foundParasiteObj.testedParasiteId != null) {
      foundParasite.setTestedParasiteId(foundParasiteObj.testedParasiteId);
    }

    if (foundParasiteObj.testedParasite != null) {
      foundParasite.setTestedParasite(_.TestedParasite.thaw(foundParasiteObj.testedParasite));
    }

    return foundParasite;
  };

  FoundParasite.thawList = function (foundParasiteObjList) {
    if (foundParasiteObjList == null) {
      return [];
    }

    var foundParasites = [];

    for (var i = 0; i < foundParasiteObjList.length; i++) {
      foundParasites.push(FoundParasite.thaw(foundParasiteObjList[i]));
    }

    return foundParasites;
  };

  FoundParasite.freeze = function (foundParasite) {
    var _a, _b, _c, _d;

    if (foundParasite == null) {
      return null;
    }

    var foundParasiteObj = {};

    if (foundParasite.getId() != null) {
      foundParasiteObj.id = foundParasite.getId();
    }

    if (foundParasite.getImageUrl() != null) {
      foundParasiteObj.imageUrl = foundParasite.getImageUrl();
    }

    if (foundParasite.getConfidence() != null) {
      foundParasiteObj.confidence = foundParasite.getConfidence();
    }

    if (foundParasite.getCreatedAt() != null) {
      foundParasiteObj.createdAt = (_b = (_a = foundParasite.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (foundParasite.getUpdatedAt() != null) {
      foundParasiteObj.updatedAt = (_d = (_c = foundParasite.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (foundParasite.getTestedParasiteId() != null) {
      foundParasiteObj.testedParasiteId = foundParasite.getTestedParasiteId();
    }

    if (foundParasite.getTestedParasite() != null) {
      foundParasiteObj.testedParasite = _.TestedParasite.freeze(foundParasite.getTestedParasite());
    }

    return foundParasiteObj;
  };

  FoundParasite.freezeList = function (foundParasites) {
    if (foundParasites == null) {
      return [];
    }

    var foundParasiteObjList = [];

    for (var i = 0; i < foundParasites.length; i++) {
      foundParasiteObjList.push(FoundParasite.freeze(foundParasites[i]));
    }

    return foundParasiteObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  FoundParasite.prototype.setId = function (id) {
    this.id = id;
  };

  FoundParasite.prototype.setImageUrl = function (imageUrl) {
    this.imageUrl = imageUrl;
  };

  FoundParasite.prototype.setConfidence = function (confidence) {
    this.confidence = confidence;
  };

  FoundParasite.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  FoundParasite.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  FoundParasite.prototype.setTestedParasiteId = function (testedParasiteId) {
    this.testedParasiteId = testedParasiteId;
  };

  FoundParasite.prototype.setTestedParasite = function (testedParasite) {
    this.testedParasite = testedParasite;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  FoundParasite.prototype.getId = function () {
    return this.id;
  };

  FoundParasite.prototype.getImageUrl = function () {
    return this.imageUrl;
  };

  FoundParasite.prototype.getConfidence = function () {
    return this.confidence;
  };

  FoundParasite.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  FoundParasite.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  FoundParasite.prototype.getTestedParasiteId = function () {
    return this.testedParasiteId;
  };

  FoundParasite.prototype.getTestedParasite = function () {
    return this.testedParasite;
  };

  return FoundParasite;
}();

var _default = FoundParasite;
exports.default = _default;